import { Observable } from "@auto/events/Observable.jsx";

export const createEvents = () => ({
  viewChanged: new Observable(),

  departmentSelected: new Observable(),
  arrondissementSelected: new Observable(),
  constituencySelected: new Observable(),
  communeSelected: new Observable(),
  sectionSelected: new Observable(),
  votingCenterSelected: new Observable(),

  createRequested: new Observable(),
  editRequested: new Observable(),
  deleteRequested: new Observable(),

  entitySaved: new Observable(),
  entityDeleted: new Observable(),

  contextMenuOpened: new Observable(),
  contextMenuClosed: new Observable(),

  pageLoadingChanged: new Observable(),
  pageErrorChanged: new Observable(),
});
